import * as API from './index'

export default {
    upload:data=> {  return API.POSTFORM('/api/MatchAttachment/Upload', data)      
    },
    uploadMusic:data=>{
        return API.POSTFORM('/api/MatchAttachment/UploadMusic', data)  
    },
    download:params=>{
        return API.GETBlog2('/api/MatchAttachment/Download', params)
    },    
     downloadFile:params=>{
        return API.GETBlog2('/api/MatchAttachment/DownloadFile', params)
    }, 
    get:params=>{
        return API.GET('/api/MatchAttachment/Get', params)
    },   
    list:params=>{
        return API.GET('/api/MatchAttachment/List', params)
    }, 
    del:params=>{
        return API.DELETE('/api/MatchAttachment/Delete', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/matchattachment.js